var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"editor-wrapper"},[_c('div',{ref:"editor",staticClass:"editor-container"}),(_vm.hasErrors)?_c('div',{staticClass:"editor-errors-container"},_vm._l((_vm.errors),function(error,index){return _c('div',{key:`error_${index}`},[_vm._v(_vm._s(error))])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }